import { defineMessages } from 'react-intl-next';

export const i18n: {
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterLabelPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectedOptionsSection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterLabelsNoText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	suggestedOptionsSection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	label: {
		id: 'search-page.filters.names.labels',
		defaultMessage: 'Label',
		description: 'Label for filtering by label',
	},
	confluenceFilterLabelPlaceholder: {
		id: 'search-page.confluence.filter.labels.placeholder',
		defaultMessage: 'Find labels',
		description: 'Placeholder for label filter search input',
	},
	selectedOptionsSection: {
		id: 'search-page.confluence.filter.label.selected',
		defaultMessage: 'Selected',
		description: 'Confluence filter label selected',
	},
	confluenceFilterLabelsNoText: {
		id: 'advanced-search.labels.filter.no.text',
		defaultMessage: 'Start typing to search for a label',
		description: "Text displayed when the user hasn't begun typing a label",
	},
	suggestedOptionsSection: {
		id: 'search-page.filter.suggested.options.section',
		defaultMessage: 'Suggested',
		description: 'Label for Suggested filter options',
	},
});
